import React from "react";
import styles from "./styles.module.scss";
import { UIText } from "src/components/uIKit";

interface UIRadioBtnProps {
  onChange: any;
  checked: boolean;
  text?: string;
  name: string;  // Added name prop for radio button grouping
  value: string; // Added value prop for radio button
  ariaLabel?: string;
  ariaLive?: "polite" | "assertive" | "off";
  ariaAtomic?: boolean;
  isHidden?: boolean;
}

const UIRadioBtn: React.FC<UIRadioBtnProps> = ({ 
  onChange, 
  checked, 
  text, 
  name,
  value,
  ariaLabel,
  ariaLive = "polite",
  ariaAtomic = true,
  isHidden = false,
}) => {
  return (
    <div aria-description={text}>
      {text ? (
        <div className={styles.radioBtnWrapper}>
          <UIText text={text} size={16} weight={400} style={styles.mRight} isAriaHidden={isHidden} />
          <input
            tabIndex={0}
            aria-live={ariaLive} 
            aria-atomic={ariaAtomic}
            aria-label={ariaLabel}
            id={`ui-radio-btn-${name}-${value}`}
            type="radio"
            checked={checked}
            onChange={onChange}
            className={styles.radio}
            name={name}
            value={value}
            aria-checked={checked}
            aria-hidden={isHidden}
          />
        </div>
      ) : (
        <input
          tabIndex={0}
          aria-hidden={isHidden}
          id={`ui-radio-btn-${name}-${value}`}
          type="radio"
          aria-live={ariaLive} 
          aria-atomic={ariaAtomic}
          aria-label={ariaLabel}
          className={styles.radio}
          checked={checked}
          onChange={onChange}
          name={name}
          value={value}
        />
      )}
    </div>
  );
};

export default UIRadioBtn; 